import { createSimpleStore, useSimpleStore } from '@passionware/simple-store';
import { useEffect, useMemo, useRef } from 'react';
import type { PageCommand, PageCommandsService } from './PageCommandsService';

export function createPageCommandsService(): PageCommandsService {
  /** Every offer standing, oldest first. */
  const offers = createSimpleStore<ReadonlyArray<PageCommand>>([]);

  return {
    useOffer(command) {
      const latest = useRef(command);
      latest.current = command;
      const { id, label, icon, hotkey } = command;
      useEffect(() => {
        // Its own object: withdrawing it leaves an equal offer of another host.
        const offer: PageCommand = {
          id,
          label,
          icon,
          hotkey,
          run: () => latest.current.run()
        };
        offers.setNewValue([...offers.getCurrentValue(), offer]);
        return () =>
          offers.setNewValue(
            offers.getCurrentValue().filter(standing => standing !== offer)
          );
      }, [id, label, icon, hotkey]);
    },
    useCommands() {
      const standing = useSimpleStore(offers);
      return useMemo(
        () => [...new Map(standing.map(offer => [offer.id, offer])).values()],
        [standing]
      );
    }
  };
}
